"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMuiRadioButton = exports.Root = void 0;
const FormControlLabel_1 = require("@mui/material/FormControlLabel");
const styles_1 = require("@mui/material/styles");
const Radio_1 = __importDefault(require("@mui/material/Radio"));
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    [`& .${FormControlLabel_1.formControlLabelClasses.label}`]: {
        [theme.breakpoints.up(1024)]: {
            fontSize: "18px"
        },
        color: theme.colours.charcoal,
        marginTop: "1px",
        wordBreak: "break-word",
        fontSize: "16px"
    }
}));
exports.StyledMuiRadioButton = (0, styles_1.styled)(Radio_1.default)(({ theme }) => ({
    color: theme.colours.inter,
    "&.Mui-disabled": {
        color: (0, styles_1.alpha)(theme.colours.inter, 0.3)
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmFkaW9CdXR0b25TdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvYnV0dG9uLXJhZGlvLWdyb3VwL3N0eWxlcy9SYWRpb0J1dHRvblN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxxRUFBeUU7QUFDekUsaURBQXFEO0FBQ3JELGdFQUFpRDtBQUVwQyxRQUFBLElBQUksR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDaEQsQ0FBQyxNQUFNLDBDQUF1QixDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDdkMsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO1lBQzVCLFFBQVEsRUFBRSxNQUFNO1NBQ2pCO1FBQ0QsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsUUFBUTtRQUM3QixTQUFTLEVBQUUsS0FBSztRQUNoQixTQUFTLEVBQUUsWUFBWTtRQUN2QixRQUFRLEVBQUUsTUFBTTtLQUNqQjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxvQkFBb0IsR0FBRyxJQUFBLGVBQU0sRUFBQyxlQUFjLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDekUsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztJQUMxQixnQkFBZ0IsRUFBRTtRQUNoQixLQUFLLEVBQUUsSUFBQSxjQUFLLEVBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsR0FBRyxDQUFDO0tBQ3ZDO0NBQ0YsQ0FBQyxDQUFDLENBQUMifQ==